export function classes(...classNames: (string | undefined | boolean)[]) {
  return classNames.filter((el) => el).join(' ');
}
